import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import moment from 'moment/min/moment-with-locales'
import { isUndefined } from 'lodash-es'

import { If, Then, Else } from '../../../sharedLegacy/components'
import { CountdownComponent } from '../WebinarCountdown/WebinarCountdown'

import './ScheduleTimerComponent.scss'

const ScheduleTimerComponent = ({ startTimeEpoch, renderOnlyTimer }) => {
  if (isUndefined(startTimeEpoch)) {
    return null
  }

  const startTime = moment.unix(startTimeEpoch)

  const countdown = <CountdownComponent timestamp={startTimeEpoch} />

  const isPast = startTime.isBefore(new Date())

  return (
    <span className="schedule-timer-component">
      <If condition={renderOnlyTimer}>
        <Then>
          <div className="icon-and-timer">{countdown}</div>
        </Then>
        <Else>
          {isPast ? (
            <FormattedMessage
              defaultMessage="Event was scheduled to be live {countdown}"
              values={{ countdown }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="Event is scheduled to be live {countdown}"
              values={{ countdown }}
            />
          )}
        </Else>
      </If>
    </span>
  )
}

ScheduleTimerComponent.propTypes = {
  startTimeEpoch: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  renderOnlyTimer: PropTypes.bool,
}

ScheduleTimerComponent.defaultProps = {
  renderOnlyTimer: false,
}

export default ScheduleTimerComponent
